import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowUpCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M23.7 15.8a1 1 0 0 1-1.5 0L17 10.5V24a1 1 0 0 1-2 0V10.5l-5.2 5.3a1 1 0 0 1-1.5 0 1 1 0 0 1 0-1.5l6.9-7A1 1 0 0 1 16 7a1.1 1.1 0 0 1 .8.3l6.9 7a1 1 0 0 1 0 1.5" />
    <path d="M4 16a12 12 0 1 0 24 0 12 12 0 0 0-24 0m-2 0a14 14 0 1 1 28 0 14 14 0 0 1-28 0" />
  </svg>
);
const ForwardRef = forwardRef(IconArrowUpCircleOutlineSVG);
ForwardRef.displayName = "IconArrowUpCircleOutline";
export { ForwardRef as IconArrowUpCircleOutline };
